module.exports = __webpack_public_path__ + "img/365123_C6E5A3_A8D18D_8EB16C-256px.8d462a5d.png";